import React from "react";

import { Stack } from "@mui/material";

import WizardTitle from "@app/analytics/account/components/WizardTitle";
import useInviteWorkspaceMembersForm from "@app/analytics/account/WorkspaceSettings/hooks/useInviteWorkspaceMembersForm";
import { WizardFormProps } from "@app/analytics/account/WorkspaceSettings/WorkspaceWizard/types";

import InviteWorkspaceMembersForm from "../components/InviteWorkspaceMembersForm";

const InviteStep = ({ form, loading, onNextStep }: WizardFormProps) => {
  const workspaceInviteForm = useInviteWorkspaceMembersForm();
  const handleConfirm = () => {
    onNextStep(workspaceInviteForm.form);
  };

  const teams = form.getValues("teams");

  return (
    <Stack spacing={3}>
      <WizardTitle
        title="Invite people to join your Workspace"
        subtitle="Invited members will need to accept the Workspace invitation before joining."
      />
      <InviteWorkspaceMembersForm
        {...workspaceInviteForm}
        context="wizard"
        loading={loading}
        onSubmit={handleConfirm}
        teams={teams}
      />
    </Stack>
  );
};

export default InviteStep;
